export default __webpack_public_path__ + "static/mastercard-749c1e2007d6121594afb99dc7ceb5e1.svg";